import { Routes } from '@angular/router'
import { isAuthenticated } from '../../core/auth/guards/auth.guard'

export const adminRoutes: Routes = [
	{
		path: 'admin',
		canActivate: [isAuthenticated],
		loadComponent: () => import('../../layout/main-layout/main-layout'),
		data: {
			role: 'ADMIN',
			title: 'Admin Dashboard',
			breadcrumb: 'Admin',
			preload: true,
			roles: ['ADMIN'],
		},
		children: [
			// Admin Dashboard
			{
				path: 'admin-dashboard',
				loadComponent: () => import('./admin-dashboard/admin-dashboard'),
				data: {
					title: 'Admin Dashboard',
					breadcrumb: 'Dashboard',
					icon: 'admin-dashboard',
					preload: true,
					roles: ['ADMIN'],
				},
			},

			// Agreement Templates
			{
				path: 'agreement-templates',
				loadComponent: () =>
					import('./admin/agreement-templates/agreement-templates').then(m => m.AgreementTemplatesComponent),
				data: {
					title: 'Agreement Templates',
					breadcrumb: 'Agreements',
					icon: 'agreement',
				},
			},

			// User Profile
			{
				path: 'profile',
				loadComponent: () => import('../trading/profile/profile'),
				data: {
					title: 'Profile',
					breadcrumb: 'Profile',
					icon: 'user',
				},
			},
			// Default redirect
			{
				path: '',
				redirectTo: 'admin-dashboard',
				pathMatch: 'full',
			},
		],
	},
]
